import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import logo from '../assets/logo.png';
export default function Dashboard() {
    return (_jsx(Box, { sx: {
            position: 'relative',
            height: '100%',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'background.default',
        }, children: _jsxs(Box, { sx: {
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                gap: 3,
                px: 4,
            }, children: [_jsx(Box, { component: "img", src: logo, alt: "Helder", sx: { width: 440, maxWidth: '70vw' } }, void 0), _jsxs(Box, { sx: {
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 1,
                        px: 2,
                        py: 0.75,
                        borderRadius: '6px',
                        bgcolor: 'rgba(54, 130, 63, 0.1)',
                    }, children: [_jsx(Box, { sx: {
                                width: 7,
                                height: 7,
                                borderRadius: '50%',
                                bgcolor: 'secondary.main',
                            } }, void 0), _jsx(Typography, { variant: "caption", sx: { fontWeight: 700, letterSpacing: 0.4, color: 'secondary.dark' }, children: "COMING SOON" }, void 0)] }, void 0), _jsxs(Box, { children: [_jsx(Typography, { variant: "h3", sx: { fontWeight: 700, letterSpacing: '-0.02em', color: 'text.primary' }, children: "Welcome back" }, void 0), _jsx(Typography, { variant: "h6", sx: { fontWeight: 400, color: 'text.secondary', mt: 1 }, children: "Your dashboard is being built \u2014 check back soon." }, void 0)] }, void 0)] }, void 0) }, void 0));
}
